import {
  ListItem,
  ListItemIcon,
  Typography,
  Box,
  makeStyles,
  createStyles,
} from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import { Draggable } from 'react-beautiful-dnd';

import { CampaignProps } from 'src/types/campaign';

import { ReactComponent as CampaignsIcon } from 'src/assets/icons/campaigns.svg';

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      padding: 0,
      alignItems: 'flex-start',
    },
    campaignContent: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      flex: 1,
    },
    iconContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: 4,
    },
    statusIcon: {
      fontSize: 16,
    },
  })
);

interface CampaignItemProps {
  campaign: CampaignProps;
  index: number;
  noDraggable?: boolean;
  onSelectCampaign: (campaignId: string) => void;
}

export const CampaignItem = ({
  campaign,
  index,
  noDraggable = false,
  onSelectCampaign,
}: CampaignItemProps) => {
  const classes = useStyles();

  const row = (
    <>
      <ListItemIcon style={{ minWidth: 30 }}>
        <CampaignsIcon
          stroke='#757575'
          fill='none'
          strokeWidth={1}
          strokeLinecap='round'
          strokeLinejoin='round'
          style={{ width: 16, height: 16 }}
        />
      </ListItemIcon>
      <Box className={classes.campaignContent}>
        <Typography
          style={{
            fontSize: 14,
            fontWeight: 400,
            lineHeight: '18px',
            flex: 1,
          }}
        >
          {campaign.name}
        </Typography>
        <Box className={classes.iconContainer}>
          <Typography
            style={{
              fontSize: 11,
              fontWeight: 400,
              color: '#667085',
              marginRight: 8,
            }}
          >
            {campaign.alignmentRequired === false ||
            campaign.alignmentRequired === undefined
              ? 'Show'
              : 'Show & Episode'}
          </Typography>
          {campaign.status === 'completed' ? (
            <CheckCircleIcon
              className={classes.statusIcon}
              style={{ color: '#10B981' }}
              titleAccess='Complete'
            />
          ) : (
            <HourglassEmptyIcon
              className={classes.statusIcon}
              style={{ color: '#F59E0B' }}
              titleAccess={
                campaign.status === 'pending'
                  ? 'Pending'
                  : campaign.status === 'failed'
                  ? 'Failed'
                  : 'Processing'
              }
            />
          )}
        </Box>
      </Box>
    </>
  );

  if (noDraggable) {
    return (
      <ListItem
        button
        className={classes.container}
        onClick={() => {
          onSelectCampaign(campaign.id);
        }}
      >
        {row}
      </ListItem>
    );
  }

  return (
    <Draggable draggableId={campaign.id} index={index}>
      {(provided) => (
        <ListItem
          button
          className={classes.container}
          onClick={() => {
            onSelectCampaign(campaign.id);
          }}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
        >
          {row}
        </ListItem>
      )}
    </Draggable>
  );
};
